// extracted by mini-css-extract-plugin
module.exports = {"tile":"Tile_tile__3l9S8","image":"Tile_image__q3B4X","name":"Tile_name__3GKWg"};